import type { RefObject } from 'react';

import { useSmoothScroll } from './useSmoothScroll';

interface UseElementScrollReturn {
  scrollToElement: (index: number) => void;
}

export const useElementScroll = (containerRef: RefObject<HTMLElement>): UseElementScrollReturn => {
  const { smoothScrollTo } = useSmoothScroll(containerRef, 400);

  const scrollToElement = (index: number) => {
    if (!containerRef.current) return;

    const container = containerRef.current;
    const element = container.children[index] as HTMLElement;
    if (!element) return;

    const containerLeft = container.getBoundingClientRect().left;
    const elementLeft = element.getBoundingClientRect().left;
    const scrollLeft = container.scrollLeft;

    const targetScroll =
      scrollLeft + (elementLeft - containerLeft) - container.offsetWidth / 2 + element.offsetWidth / 2;

    smoothScrollTo(targetScroll);
  };

  return { scrollToElement };
};
